import React from "react";
import ct from "class-types.macro";
import LoginLink from "./LoginLink";
import { VariantProps } from ".";
import StandardPrice from "../Price";

const B = (props: VariantProps) => {
  const { selectedProduct, productListingView } = props;

  return (
    <div className="map map-override mapB">
      <StandardPrice
        price={selectedProduct.price.price}
        unitOfMeasure={selectedProduct.unitOfMeasure}
        productListingView={productListingView}
      />
      {selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers && (
        <p
          className={ct(
            "font-semibold",
            "text-xs",
            "mb-0",
            "text-gray-800",
            productListingView === "list"
              ? ct("leading-tight", "mt-1", "xs:mt-0", "xs:text-center")
              : ct("leading-none", "text-center"),
          )}
        >
          <LoginLink>Login</LoginLink>
          {" for details"}
        </p>
      )}
    </div>
  );
};

export default B;
